import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.config.productionTip = false

Vue.use(ElementUI);
import request from "@/api/request";
Vue.prototype.$postRequest = request.post
Vue.prototype.$getRequest = request.get
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
